<script setup>
import { Dialog, DialogOverlay, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue';
import { useConfirmDialog } from '@/shared/composables/useConfirmDialog.js';
import CFButton from '@/ui/Button/CFButton.vue';
import CFCircleCloseButton from '@/shared/components/CFCircleCloseButton.vue';

const { state, onConfirm, onCancel, afterLeave } = useConfirmDialog();
</script>

<template>
    <Teleport to="body">
        <TransitionRoot
            appear
            as="template"
            :show="state.isOpen"
            @after-leave="afterLeave"
        >
            <Dialog
                class="relative z-50"
                @close="onCancel"
            >
                <TransitionChild
                    as="template"
                    enter="ease-out duration-300"
                    enter-from="opacity-0"
                    enter-to="opacity-100"
                    leave="ease-in duration-200"
                    leave-from="opacity-100"
                    leave-to="opacity-0"
                >
                    <DialogOverlay class="fixed inset-0 bg-black/40" />
                </TransitionChild>

                <div class="fixed inset-0 flex items-center justify-center p-4">
                    <TransitionChild
                        as="template"
                        enter="ease-out duration-300"
                        enter-from="opacity-0 scale-95"
                        enter-to="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leave-from="opacity-100 scale-100"
                        leave-to="opacity-0 scale-95"
                    >
                        <DialogPanel class="relative w-full max-w-md bg-gray-50 p-7 shadow-lg">
                            <CFCircleCloseButton
                                class="absolute top-6 right-5"
                                @click="onCancel"
                            />

                            <DialogTitle class="mr-6 text-base font-bold text-black">
                                {{ state.title }}
                            </DialogTitle>

                            <p
                                v-if="state.description"
                                class="mt-4 text-sm text-black"
                            >
                                {{ state.description }}
                            </p>

                            <div class="mt-7 flex justify-between gap-3 border-t border-black pt-5">
                                <CFButton
                                    color="primary"
                                    size="lg"
                                    variant="outline"
                                    :disabled="state.loading"
                                    @click="onCancel"
                                >
                                    {{ state.cancelLabel }}
                                </CFButton>

                                <CFButton
                                    color="primary"
                                    size="lg"
                                    :loading="state.loading"
                                    @click="onConfirm"
                                >
                                    {{ state.confirmLabel }}
                                </CFButton>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </Dialog>
        </TransitionRoot>
    </Teleport>
</template>
